export default __webpack_public_path__ + "static/media/memory_game_preview.30c9cc9b.png";